import Vue from 'vue'
import Vuex from 'vuex'
import { getCookie } from '@/assets/js/public'
Vue.use(Vuex);
const state = { //state
    if_login: false,
    tab_type: 1,
    userName: localStorage.getItem("doc_name"),
    password: "",
    articleType:0,
    article:{}
};
const mutations = {
    userName(state, data) {
        state.userName = data;
    },
};
const actions = {

};
export default new Vuex.Store({
    state,
    mutations,
    actions
})


// WEBPACK FOOTER //
// ./src/store.js